import { render, staticRenderFns } from "./PackingForm.vue?vue&type=template&id=40bcb0e1&"
import script from "./PackingForm.vue?vue&type=script&lang=js&"
export * from "./PackingForm.vue?vue&type=script&lang=js&"
import style0 from "./PackingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports